import { render, staticRenderFns } from "./shopMall.vue?vue&type=template&id=8dff76ec&scoped=true&"
import script from "./shopMall.vue?vue&type=script&lang=js&"
export * from "./shopMall.vue?vue&type=script&lang=js&"
import style0 from "./shopMall.vue?vue&type=style&index=0&id=8dff76ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dff76ec",
  null
  
)

export default component.exports